import { render, staticRenderFns } from "./VTemplateActivityLog.vue?vue&type=template&id=b18b7bd2&scoped=true&lang=pug"
import script from "./VTemplateActivityLog.vue?vue&type=script&lang=ts"
export * from "./VTemplateActivityLog.vue?vue&type=script&lang=ts"
import style0 from "./VTemplateActivityLog.vue?vue&type=style&index=0&id=b18b7bd2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18b7bd2",
  null
  
)

/* custom blocks */
import block0 from "./RTemplateActivityLog.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FTemplate%2Fviews%2FActivityLog%2FVTemplateActivityLog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports